import React, { useContext } from "react";
import { Navbar } from "./Navbar";
import { RootStoreContext } from "../../stores/rootStore";
import { Link } from "react-router-dom";
export const Header = () => {
  const rootStore = useContext(RootStoreContext);
  const { currentShop } = rootStore.commonStore;
  const baseUrl = process.env.REACT_APP_ADMIN_API_URL
  const key = currentShop?.apiKey
  return (
    <header>
      <div className="navbar-brand">
        <Link className="navbar-logo" to="/order">
          <img
            src={currentShop?.logoPath ? `${baseUrl}/${currentShop?.uniqueRecId.toLowerCase()}/logo/${currentShop?.uniqueRecId.toLowerCase()}_logo?key=${key}` : "/images/logo-v.png"}
            alt={currentShop?.shopName || "My Drycleaner"}
          />
        </Link>
        <h1 className="logo-title">
          {currentShop?.showCompanyName && (
          currentShop?.shopName || "My Drycleaner")}
        </h1>
      </div>
      <input type="checkbox" id="navbar-toggler" className="navbar-toggler" />
      <Navbar />
      <label htmlFor="navbar-toggler" className="navbar-hamburger">
        <span></span>
      </label>
    </header>
  );
};
